import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { setConfig } from 'react-hot-loader';

import amplitude from './utils/services/amplitude';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import store from './config/createStore';

amplitude.init();

setConfig({
  ignoreSFC: true,
  pureRender: true
});

const Root = () => (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
